<ion-content [fullscreen]="true" class="soft-page">
  <div class="content-wrapper" data-guide="history">

    <div class="page-header">
      <h2 class="page-title">Storico Allerte</h2>
    </div>

    @if (guide.historyExampleVisible()) {
      <div class="alerts-list" data-guide="history-example">
        <ng-container *ngTemplateOutlet="alertCard; context: { $implicit: historyExampleAlert, example: true }"></ng-container>
      </div>
    }
    <div class="alerts-list" [style.display]="guide.historyExampleVisible() ? 'none' : null">
      @if (isLoading) {
      @for (i of [1,2,3,4,5,6]; track i) {
      <div class="soft-card alert-card-compact skeleton-card">
        <div class="card-top-row">
          <div class="left-section">
            <div class="skeleton-block icon-bubble-sk"></div>
            <div class="text-info" style="width: 100%;">
              <div class="skeleton-block title-sk"></div>
              <div class="skeleton-block subtitle-sk"></div>
            </div>
          </div>
          <div class="skeleton-block badge-sk"></div>
        </div>

        <div class="skeleton-block timeline-sk"></div>
      </div>
      }
      } @else {
      @for (alert of alertsHistory; track alert.id) {
        <ng-container *ngTemplateOutlet="alertCard; context: { $implicit: alert }"></ng-container>
      }
      }
    </div>

    <ng-template #alertCard let-alert let-example="example">
      <div class="soft-card alert-card-compact" [ngClass]="getAlertColorClass(alert.eventType)">

        <div class="card-top-row" data-guide="history-card-header">

          <div class="left-section">
            <div class="icon-bubble">
              <mat-icon [svgIcon]="eventTypeToData[alert.eventType].svgIcon"></mat-icon>
            </div>
            <div class="text-info">
              <span class="alert-entity">{{ alert.eventType === '08' ? alert.title : eventTypeToData[alert.eventType].name }}</span>
              @if (alert.eventType === '08') {
              <span>{{ alert.body }}</span>
              }
              <span class="location-text">
                {{ example ? ('GUIDE.HISTORY_EXAMPLE.ROOM' | translate) : (alert.facilities.room.name || '') }} {{ alert.facilities.bed?.name ? '• ' + alert.facilities.bed!.name
                : '' }}
              </span>
            </div>
          </div>

          <div class="manager-badge">
            <span class="manager-name">{{ roleToText(alert.managed_by_info.role) }}</span>
            <ion-icon [name]="alert.managedBy === 'system' ? 'server-outline' : 'person-circle-outline'"></ion-icon>
          </div>

        </div>

        <div class="timeline-compact" data-guide="history-card-timeline">
          <div class="t-point start">
            <ion-icon name="time-outline"></ion-icon>
            <span>{{ alert.timestamp | date:'HH:mm' }}</span>
          </div>

          <div class="t-line">
            <span class="duration-pill">{{ getDuration(alert.timestamp, alert.managedAt) }}</span>
          </div>

          <div class="t-point end">
            <ion-icon name="checkmark-done-outline"></ion-icon>
            <span>{{ alert.managedAt | date:'HH:mm' }}</span>
          </div>
        </div>

      </div>
    </ng-template>

  </div>
</ion-content>
